module.exports = __webpack_public_path__ + "static/homepage-reservation-button-1-6a8632f0e26f5eae5d434b5baee3778b.png";